import React from 'react';
import Typography from '@material-ui/core/Typography';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { colors } from '../../../themes/colors';
import { VisitsRemainingNode } from '../../../generated/webapp_gql';
import { InsuranceStatus } from '../../../constants';

const styles = () =>
  createStyles({
    visitsDataBorderRight: {
      borderRight: `1px solid ${colors.gray1}`,
    },
    visitsData: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      padding: '16px 0',
      flexGrow: 1,
    },
    visitsDataTop: {
      fontFamily: 'Avenir-Black',
      fontSize: 24,
      color: colors.black3,
    },
    visitsDataMiddle: {
      fontFamily: 'Avenir-Black',
      fontSize: 14,
      color: colors.black3,
    },
    visitsDataBottom: {
      fontFamily: 'Avenir-Medium',
      fontSize: 12,
      color: colors.gray11,
    },
    visitsRow: {
      display: 'flex',
    },
  });

type Props = WithStyles<typeof styles> & {
  insuranceStatus?: string | undefined | null;
  isCompanyHpiEnabled?: boolean | undefined | null;
  visitsRemaining?: VisitsRemainingNode;
};

const SessionsInfoSection: React.FC<Props> = ({
  classes,
  insuranceStatus,
  isCompanyHpiEnabled,
  visitsRemaining,
}) => {
  const { showHpiClientStatusInfo } = useFlags();

  const shouldShowHpiTherapySessionInfo =
    showHpiClientStatusInfo &&
    isCompanyHpiEnabled &&
    visitsRemaining?.therapyVisitsRemaining === 0 &&
    insuranceStatus === InsuranceStatus.ELIGIBLE;

  return (
    <div className={classes.visitsRow}>
      <div className={classNames(classes.visitsData, classes.visitsDataBorderRight)}>
        <Typography className={classes.visitsDataTop}>
          {visitsRemaining?.coachingVisitsRemaining}
        </Typography>

        <Typography className={classes.visitsDataMiddle}>Coaching Sessions</Typography>

        <Typography className={classes.visitsDataBottom}>remaining</Typography>
      </div>

      <div className={classes.visitsData}>
        {shouldShowHpiTherapySessionInfo && (
          <>
            <Typography className={classes.visitsDataTop}>Unlimited</Typography>

            <Typography className={classes.visitsDataMiddle}>Therapy Sessions</Typography>

            <Typography className={classes.visitsDataBottom}>covered by Health Plan</Typography>
          </>
        )}

        {!shouldShowHpiTherapySessionInfo && (
          <>
            <Typography className={classes.visitsDataTop}>
              {visitsRemaining?.therapyVisitsRemaining}
            </Typography>

            <Typography className={classes.visitsDataMiddle}>Therapy Sessions</Typography>

            <Typography className={classes.visitsDataBottom}>remaining</Typography>
          </>
        )}
      </div>
    </div>
  );
};

export default withStyles(styles)(SessionsInfoSection);
